// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__11EyZ","center_box_img":"centerView_center_box_img__CMlrr","hide":"centerView_hide__3CXiE"};